var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateEventSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magic-wand 1",
    clipPath: "url(#clip0_1134_57457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3105 23.0676C16.4685 23.6589 16.9718 24.0921 17.5764 24.1643L25.8491 25.1507L26.8354 33.4233C26.908 34.0365 27.351 34.5343 27.9321 34.6892C28.5232 34.847 29.1495 34.6294 29.5158 34.1414L34.5054 27.4702L42.162 30.7521C42.7243 30.9924 43.3754 30.8677 43.8077 30.4354C44.2401 30.0031 44.365 29.3521 44.1246 28.7897L40.8425 21.1331L47.5137 16.1435C48.0018 15.7772 48.2195 15.1509 48.0616 14.5598C47.9038 13.9685 47.4003 13.5331 46.7956 13.4631L38.5232 12.4768L37.5368 4.2041C37.4655 3.59837 37.0312 3.09594 36.4399 2.93816C35.8489 2.78018 35.2225 2.99803 34.8563 3.48601L29.8668 10.1573L22.21 6.87532C21.6477 6.63477 20.9968 6.75968 20.5643 7.19198C20.132 7.62429 20.0073 8.27533 20.2476 8.83773L23.5296 16.4943L16.8583 21.4839C16.3703 21.8502 16.1528 22.4765 16.3105 23.0676Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M43.8088 9.30503L45.9218 7.19201C46.5059 6.608 46.5059 5.66301 45.9218 5.079C45.338 4.49499 44.3928 4.49499 43.8088 5.079L41.6958 7.19201C41.1118 7.77602 41.1118 8.72122 41.6958 9.30503C42.2798 9.88904 43.2248 9.88904 43.8088 9.30503Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.7062 5.82507C29.5036 5.6115 29.9762 4.79222 29.7626 3.99474L28.9889 1.10787C28.7731 0.310293 27.9561 -0.162254 27.1585 0.0513084C26.3611 0.264871 25.8885 1.08416 26.1021 1.88163L26.8758 4.76851C27.0873 5.55841 27.9024 6.03923 28.7062 5.82507Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M35.6665 31.8023C34.8689 32.0159 34.3963 32.8352 34.6099 33.6327L35.3838 36.5195C35.5951 37.3094 36.4102 37.7903 37.2141 37.5761C38.0117 37.3625 38.4842 36.5432 38.2706 35.7458L37.4968 32.8589C37.2821 32.0625 36.463 31.5877 35.6665 31.8023Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.1413 13.5033L15.2544 12.7297C14.4569 12.5161 13.6376 12.9885 13.424 13.786C13.2098 14.5911 13.6918 15.4053 14.4806 15.6163L17.3675 16.3902C18.165 16.6038 18.9841 16.1312 19.1978 15.3337C19.4102 14.5351 18.9356 13.7158 18.1413 13.5033Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M45.174 22.2939C44.9598 23.0987 45.4418 23.913 46.2306 24.1242L49.1175 24.8979C49.915 25.1115 50.7341 24.6391 50.9478 23.8415C51.1614 23.044 50.6848 22.2227 49.8914 22.0112L47.0045 21.2373C46.2069 21.0238 45.3876 21.4963 45.174 22.2939Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M2.55107 50.5619C3.13488 51.1459 4.08008 51.1459 4.66409 50.5619L23.6102 31.616L23.1601 27.84L19.3844 27.3899L0.437858 46.336C-0.145953 46.92 -0.145953 47.865 0.437858 48.449L2.55107 50.5619Z",
    fill: "#34A853"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1134_57457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateEventSvg);
export default __webpack_public_path__ + "static/media/CreateEventSvg.41f569f0e64a579d9f11cbee615ce44f.svg";
export { ForwardRef as ReactComponent };